export default __webpack_public_path__ + "static/media/user.d01758b8.jpg";